/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import {
  Badge, Card, CardBody, Col, Collapse,
} from 'reactstrap';
import PropTypes from 'prop-types';

import CloseIcon from 'mdi-react/CloseIcon';
import MinusIcon from 'mdi-react/MinusIcon';
import AutorenewIcon from 'mdi-react/AutorenewIcon';
import LoadingSpinner from './widgets/LoadingSpinner';

export default class Panel extends PureComponent {
  static propTypes = {
    divider: PropTypes.bool,
    color: PropTypes.string,
    title: PropTypes.string,
    subhead: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    sm: PropTypes.number,
    xs: PropTypes.number,
    before: PropTypes.element,
    panelClass: PropTypes.string,
    getData: PropTypes.func,
    parentRefresh: PropTypes.bool,
    showButtons: PropTypes.bool,
    showMinusButton: PropTypes.bool,
    showRefreshButton: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    showNameButton: PropTypes.bool,
    defaultOpen: PropTypes.bool,
  };

  static defaultProps = {
    divider: false,
    color: '',
    title: '',
    subhead: '',
    label: '',
    icon: '',
    md: 0,
    lg: 0,
    xl: 0,
    sm: 0,
    xs: 0,
    before: null,
    panelClass: '',
    getData: null,
    parentRefresh: false,
    showButtons: true,
    showMinusButton: true,
    showRefreshButton: true,
    showCloseButton: false,
    showNameButton: false,
    defaultOpen: true,
  };

  constructor() {
    super();

    this.state = {
      visible: true,
      collapse: true,
      refresh: false,
    };
  }

  // showing = () => {
  //   const { visible } = this.state;
  //   return visible;
  // };

  // onShow = () => {
  //   this.setState({ visible: true });
  // };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  onCollapse = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  onRefresh = () => {
    const { getData } = this.props;
    // your async logic here
    this.setState(prevState => ({ refresh: !prevState.refresh }));
    if (getData) {
      getData();
      this.setState({ refresh: false });
    } else {
      setTimeout(() => this.setState({ refresh: false }), 5000);
    }
  };

  render() {
    const {
      md, lg, xl, sm, xs, color, divider, icon, title, label, subhead, before,
      panelClass, children, parentRefresh, showButtons, defaultOpen, showMinusButton, showRefreshButton, showCloseButton, showNameButton,
    } = this.props;

    const { collapse, refresh, visible } = this.state;

    if (visible) {
      return (
        <Col md={md} lg={lg} xl={xl} sm={sm} xs={xs}>
          <Card
            className={`panel${color ? ` panel--${color}` : ''}
            ${divider ? ' panel--divider' : ''}${(collapse === defaultOpen) || !parentRefresh ? '' : ' panel--collapse'} ${panelClass}`}
          >
            <CardBody className="panel__body">
              {(refresh || parentRefresh) ? <LoadingSpinner active={refresh || parentRefresh} wrap /> : ''}
              {showButtons && (
                <div className="panel__btns">
                  {showMinusButton && (
                    <button className="panel__btn" type="button" onClick={this.onCollapse}><MinusIcon /></button>
                  )}
                  {showRefreshButton && (
                    <button className="panel__btn" type="button" onClick={this.onRefresh}><AutorenewIcon /></button>
                  )}
                  {showCloseButton && (
                    <button className="panel__btn" type="button" onClick={this.onDismiss}><CloseIcon /></button>
                  )}
                </div>
              )}
              {showNameButton && (
                <div className="panel__title" role="button" tabIndex="0" onClick={this.onCollapse} onKeyDown={this.onCollapse}>
                  <h5 className="bold-text">
                    {icon ? <span className={`panel__icon lnr lnr-${icon}`} /> : ''}
                    {title}
                    <Badge className="panel__label">{label}</Badge>
                  </h5>
                  <h5 className="subhead">{subhead}</h5>
                </div>
              )}
              {!showNameButton && (
                <div className="panel__title">
                  <h5 className="bold-text">
                    {icon ? <span className={`panel__icon lnr lnr-${icon}`} /> : ''}
                    {title}
                    <Badge className="panel__label">{label}</Badge>
                  </h5>
                  <h5 className="subhead">{subhead}</h5>
                </div>
              )}
              <Collapse isOpen={(collapse === defaultOpen) && !parentRefresh}>
                <div className="panel__content">
                  {children}
                </div>
              </Collapse>
            </CardBody>
          </Card>
          {before}
        </Col>
      );
    }

    return '';
  }
}

export const PanelTitle = ({ title }) => (
  <div className="panel__title">
    <h5 className="bold-text">
      {title}
    </h5>
  </div>
);
